export default {"src":"/_next/static/media/Jenkins.e0835859.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};